import { render, staticRenderFns } from "./Laying.vue?vue&type=template&id=f5c18f82&"
import script from "./Laying.vue?vue&type=script&lang=js&"
export * from "./Laying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports